import { trigger } from 'alpinejs';
import type { gsap } from 'gsap';

const PhoneAnimation = (containerSelector) => {
  return (gsap: gsap, ScrollTrigger): () => void => {
    const init = (el: HTMLElement) => {
      const container = el.closest(containerSelector);
      const screen = el.querySelector('.ce-hero-phone-screen');
      let screenLabelAnimated = false;

      gsap.set(el, {
        rotationX: 8,
        rotationY: 12,
        rotationZ: 0,
        xPercent: 25,
        yPercent: 15,
      });

      gsap.to(el, {
        rotationX: 0,
        rotationY: 0,
        rotationZ: -15.2,
        xPercent: 0,
        yPercent: 0,
        scrollTrigger: {
          trigger: container,
          start: () => 0,
          end: () => 'top top',
          scrub: true,
          invalidateOnRefresh: true,
          onLeave: () => {
            if (screenLabelAnimated) {
              return;
            }

            screenLabelAnimated = true;
            gsap.to(screen?.querySelector('.ce-hero-phone-screen-label'), {
              keyframes: {
                scale: [1, 1.3, 1],
                ease: 'power2.inOut',
              },
              duration: 1.4,
            });
          },
        },
      });

      ScrollTrigger.create({
        trigger: container,
        start: () => 'bottom top',
        end: () => 'bottom bottom',
        onEnter: () => {
          document.documentElement.classList.add('phone-animation-active');
        },
        onEnterBack: () => {
          document.documentElement.classList.add('phone-animation-active');
        },
        onLeave: () => {
          document.documentElement.classList.remove('phone-animation-active');
        },
        onLeaveBack: () => {
          document.documentElement.classList.remove('phone-animation-active');
        }
      });

      // const tl = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: container,
      //     pin: true,
      //     start: () => 'top top', // when the top of the trigger hits the top of the viewport
      //     end: () => `+=${300 * items.length}`, // let each be visible 300px of scrolling
      //     scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      //     invalidateOnRefresh: true,
      //     onEnter: () => {
      //       document.documentElement.classList.add('phone-animation-active');
      //     },
      //     onEnterBack: () => {
      //       document.documentElement.classList.add('phone-animation-active');
      //     },
      //     onLeave: () => {
      //       document.documentElement.classList.remove('phone-animation-active');
      //     },
      //     onLeaveBack: () => {
      //       document.documentElement.classList.remove('phone-animation-active');
      //     },
      //     markers: window.location.host === 'localhost:8080',
      //   }
      // });

      // items.forEach((item, i) => {
      //   gsap.set(item, {
      //     opacity: i === 0 ? 1 : 0,
      //   });

      //   tl.to(item, { opacity: 1, duration: 0.2 }, '-=0.2');

      //   if (i !== items.length - 1) {
      //     tl.to(item, { opacity: 0, duration: 0, delay: 0.8 }, '+=0.2');
      //   }
      // });
    }

    (document.querySelectorAll('.ce-hero-phone') as NodeListOf<HTMLElement>).forEach(init);

    // cleanup function - executes when media not matched
    return () => {
      gsap.set('.ce-hero-phone', {
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        xPercent: 0,
        yPercent: 0,
      });
    };
  };
};

export const ClickPhoneScreen = (gsap: gsap) => {
  const init = (el: HTMLElement) => {
    const items = el.querySelectorAll('.ce-hero-phone-item');

    if (items.length < 2) {
      return;
    }

    let currentIndex = 0;
    items.forEach((item, i) => {
      gsap.set(item, {
        opacity: i === 0 ? 1 : 0,
      });
    });

    const screen = el.querySelector('.ce-hero-phone-screen');
    screen?.addEventListener('click', () => {
      if (!screen.classList.contains('active')) {
        screen.classList.add('active');
        return;
      }

      const nextIndex = currentIndex + 1 < items.length ? currentIndex + 1 : 0;
      gsap.to(items[currentIndex], { opacity: 0, duration: 0, delay: 0.2 });
      gsap.to(items[nextIndex], { opacity: 1, duration: 0.2, delay: 0 });
      currentIndex = nextIndex;
    });
  };

  (document.querySelectorAll('.ce-hero-phone') as NodeListOf<HTMLElement>).forEach(init);
}

export const PhoneAnimationDesktop = PhoneAnimation('.ce-hero-phone-animation-container');
// export const PhoneAnimationMobile = PhoneAnimation('.ce-hero-phone-wrapper');
